<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Deleted Receipts Logs</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="4" md="4">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
              item-value="id" label="Academic Year" @change="getLogsForAy()" outlined persistent-hint
              hint="Please Select Academic Year" />
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="logs_list.length > 0">
        <v-toolbar flat class="toolbar">
          <v-toolbar-title>Deleted Receipts Logs</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <v-btn class="ma-2 no-display " rounded color="success" outlined
              @click="fnExcelReport('my-table-id', 'DeletedReceiptsLogsReport')" :loading="loader"><v-icon
                color="success">mdi-export</v-icon>Export</v-btn>
          </v-col>
          <v-col cols="12" sm="2" md="2"></v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="search" class="mr-2 pb-3 pt-2" append-icon="search" label="Search" single-line
              hide-details>
            </v-text-field>
          </v-col>
        </v-row>
        <div id="my-table-id">
          <v-data-table class="mytable" :headers="headers" :items="filteredItems">
            <!-- <template v-slot:top> -->
            <!-- <v-toolbar flat class="toolbar">
              <v-toolbar-title>Deleted Receipts Logs</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <br /> -->
            <!-- </template> -->
          </v-data-table>
        </div>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    logs_list: [],
    ay: "",
    search: "",
    headers: [
      { text: "Sr. No.", value: "srno" },
      { text: "Student", value: "learner" },
      { text: "Academicyear", value: "academicyear" },
      { text: "Receipt No", value: "receipt_no" },
      { text: "Receipt Date", value: "receipt_date" },
      { text: "Amount", value: "amount" },
      { text: "Transaction Id", value: "transaction_id" },
      { text: "Transaction Date", value: "transaction_date" },
      { text: "Payment Mode", value: "paymentmode" },
      { text: "Bank", value: "bank" },
      { text: "Payment Type", value: "paymenttype" },
      { text: "Receipt Deleted Date", value: "deleted_date" },
      { text: "Receipt Deleted Reason", value: "reason_for_delete" },
    ],
    table_fields: {
      "Sr. No.": "srno",
      Student: "learner",
      Academicyear: "academicyear",
      "Receipt No": "receipt_no",
      "Receipt Date": "receipt_date",
      Amount: "amount",
      "Transaction Id": "transaction_id",
      "Transaction Date": "transaction_date",
      "Payment Mode": "paymentmode",
      Bank: "bank",
      "Payment Type": "paymenttype",
      "Receipt Deleted Date": "deleted_date",
      "Receipt Deleted Reason": "reason_for_delete",
    },
  }),
  computed: {
    filteredItems() {
      if (!this.search) {
        return this.logs_list;
      }
      const search = this.search.toLowerCase();
      return this.logs_list.filter(item => {
        return (
          item.learner.toLowerCase().includes(search) ||
          item.academicyear.toLowerCase().includes(search) ||
          item.receipt_no.toLowerCase().includes(search) ||
          item.receipt_date.toLowerCase().includes(search) ||
          item.amount.toString().includes(search) ||
          item.transaction_id.toLowerCase().includes(search) ||
          item.transaction_date.toLowerCase().includes(search) ||
          item.paymentmode.toLowerCase().includes(search) ||
          item.bank.toLowerCase().includes(search) ||
          item.paymenttype.toLowerCase().includes(search) ||
          item.deleted_date.toLowerCase().includes(search) ||
          item.reason_for_delete.toLowerCase().includes(search)
        );
      });
    },
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>SR. No.</th>
      <th>Student</th>
      <th>Academic Year</th>
      <th>Reciept No</th>
      <th>Reciept Date</th>
      <th>Amount</th>
      <th>Transaction Id</th>
      <th>Transaction Date</th>
      <th>Payment Mode</th>
      <th>Bank</th>
      <th>Payment Type</th>
      <th>Reciept Deleted Date</th>
      <th>Reciept Deleted Reason</th>
    </tr>`;

  this.logs_list.forEach((item, index) => {
    tab_text += `
    <tr>
        <td>${index + 1}</td>
        <td>${item.learner}</td>
        <td>${item.academicyear}</td>
        <td>${item.receipt_no}</td>
        <td>${item.receipt_date}</td>
        <td>${item.amount}</td>
        <td>${item.transaction_id}</td>
        <td>${item.transaction_date}</td>
        <td>${item.paymentmode}</td>
        <td>${item.bank}</td>
        <td>${item.paymenttype}</td>
        <td>${item.deleted_date}</td>
        <td>${item.reason_for_delete}</td>
      </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    getLogsForAy() {
      const formData = {
        ay: this.ay,
      };
      axios
        .post("FeesStructureInstallment/getLogsForAy", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.logs_list = res.data.logs_list;
          } else {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    onload() {
      axios
        .post("FeesStructureInstallment/getDeletedReceipsLogs")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.logs_list = res.data.logs_list;
            if (this.logs_list == "") {
              this.showSnackbar("#b71c1c", "No Records Found...");
            }
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onload();
  },
  watch: {},
};
</script>
<style scoped>
</style>